import moment from 'moment';

// Same convention as isAiConsentAccepted in aiConsent.js: the account API
// serialises .NET's DateTime.MinValue instead of null for an unset consent
// date, so "unset" has to be detected by value rather than by absence.
const isUnsetOrInvalid = (value) => {
  if (!value) {
    return true;
  }
  const parsed = moment.utc(value);
  return !parsed.isValid() || parsed.year() <= 1;
};

// Current version date of each legal document. Bump the relevant date here
// whenever a document is republished so accounts that accepted an earlier
// version are asked to re-confirm via the legal consent modal.
export const LEGAL_DOCUMENT_VERSIONS = {
  generalTerms: '2021-06-08',
  dataPolicy: '2026-09-15',
  dataProcessing: '2026-09-15',
};

export const LEGAL_DOCUMENT_LINKS = {
  generalTerms: 'https://hellohousing.de/wp-content/legal/AGB.pdf',
  dataPolicy: 'https://hellohousing.de/legal/Datenschutzerkla%CC%88rung%20hellohousing%20WebApp.pdf',
  dataProcessing: 'https://hellohousing.de/legal/AVV%20hellohousing%20WebApp.pdf',
};

const isAcceptedForCurrentVersion = (acceptedAt, versionDate) => {
  if (isUnsetOrInvalid(acceptedAt)) {
    return false;
  }
  return !moment.utc(acceptedAt).isBefore(moment.utc(versionDate), 'day');
};

export const isGeneralTermsAccepted = (accountData) =>
  isAcceptedForCurrentVersion(accountData?.consents?.generalTermsAcceptedOn, LEGAL_DOCUMENT_VERSIONS.generalTerms);

export const isDataPolicyAccepted = (accountData) =>
  isAcceptedForCurrentVersion(accountData?.consents?.dataPolicyAcceptedOn, LEGAL_DOCUMENT_VERSIONS.dataPolicy);

export const isDataProcessingAccepted = (accountData) =>
  isAcceptedForCurrentVersion(accountData?.consents?.dataProcessingAcceptedOn, LEGAL_DOCUMENT_VERSIONS.dataProcessing);

export const needsLegalConsent = (accountData) =>
  !!accountData?.consents &&
  (!isGeneralTermsAccepted(accountData) || !isDataPolicyAccepted(accountData) || !isDataProcessingAccepted(accountData));

// DD.MM.YYYY, matching the display convention used across the app (e.g.
// Legal.js) — returns null for an unset/invalid date instead of "01.01.0001".
export const formatAcceptedDate = (acceptedAt) =>
  isUnsetOrInvalid(acceptedAt) ? null : moment(acceptedAt).format('DD.MM.YYYY');
